import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchGroupedBalanceSheetApi,
  addBalanceSheetApi,
  updateBalanceSheetApi,
  deleteBalanceSheetApi,
} from "../services/balanceSheetService";
// Fetch grouped balance sheet entries by date range
export const fetchGroupedBalanceSheet = createAsyncThunk(
  "balanceSheet/fetchGroupedBalanceSheet",
  async ({ fromDate = "", toDate = "", nameFilter = "" }) => {
    const response = await fetchGroupedBalanceSheetApi(
      fromDate,
      toDate,
      nameFilter
    );
    console.log("response", response);
    return response;
  }
);
// Add new balance sheet entry
export const addBalanceSheet = createAsyncThunk(
  "balanceSheet/addBalanceSheet",
  async (balanceSheetData) => {
    console.log("balanceSheetData:", balanceSheetData);
    const response = await addBalanceSheetApi(balanceSheetData);
    console.log("API Response on Add balance sheet:", response);
    return response;
  }
);
// Update balance sheet entry
export const updateBalanceSheet = createAsyncThunk(
  "balanceSheet/updateBalanceSheet",
  async (balanceSheetData) => {
    console.log("updateBalanceSheetData:", balanceSheetData);
    const response = await updateBalanceSheetApi(balanceSheetData);
    console.log("API Response on Update balance sheet:", response);
    return response;
  }
);
// Delete balance sheet entry
export const deleteBalanceSheet = createAsyncThunk(
  "balanceSheet/deleteBalanceSheet",
  async (balanceSheetId) => {
    console.log("deleteBalanceSheetId:", balanceSheetId);
    const response = await deleteBalanceSheetApi(balanceSheetId);
    console.log("API Response on Delete balance sheet:", response);
    return response;
  }
);
const balanceSheetSlice = createSlice({
  name: "balanceSheet",
  initialState: {
    groupedBalanceSheet: [],
    totals: {
      paid: 0,
      debit: 0,
      balance: 0,
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGroupedBalanceSheet.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchGroupedBalanceSheet.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.groupedBalanceSheet = action.payload.grouped_balance_sheets || [];
        const newTotals = action.payload.totals || {};
        state.totals = {
          paid: newTotals.paid ?? 0,
          debit: newTotals.debit ?? 0,
          balance: newTotals.balance ?? 0,
        };
      })
      .addCase(fetchGroupedBalanceSheet.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(addBalanceSheet.pending, (state) => {
        state.status = "loading";
      })
      .addCase(addBalanceSheet.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log("action.payload:", action.payload);
        // Refetch after add (handled in component)
      })
      .addCase(addBalanceSheet.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(updateBalanceSheet.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateBalanceSheet.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log("action.payload:", action.payload);
        // Refetch after update (handled in component)
      })
      .addCase(updateBalanceSheet.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(deleteBalanceSheet.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteBalanceSheet.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log("action.payload:", action.payload);
        // Refetch after delete (handled in component)
      })
      .addCase(deleteBalanceSheet.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});
export default balanceSheetSlice.reducer;
